<div class="mb-4 align-center">
    <img src="assets/img/selfLearn/quit.svg" alt="QUIT" />
</div>
<h4 class="quit-txt">{{data?.message}}</h4>
<p *ngIf="data?.isMessage2 != false" class="warn-msg" [innerHTML]="data?.message2"></p>
<!-- <p *ngIf="data?.isMessage2 != false" >You’re just {{data?.num}} cards away to finish this</p> -->
<div class="quit-btn-set">
    <button style="background-color: #FBD323" class="btn btn-primary btn-block assessment_mb-0 resume-btn" type="button"
    (click)="resume()"> <span style="color: #1E2A36;"> RESUME </span>
    </button>
    <button style="background-color: #3C8DCB" class="btn btn-block assessment_mt-15 assessment_mb-0 quit-btn" type="button"
    (click)="quitLearning()">QUIT LEARNING </button>
</div>